import { Link } from 'react-router-dom'
import { useState } from 'react'
import { User, VersionResponse } from '../types'
import SettingsModal from './SettingsModal'

interface AppLayoutProps {
  user: User
  uptime?: string
  version?: VersionResponse | null
  fullBleed?: boolean
  children: React.ReactNode
}

function AppLayout({ user, uptime, version, fullBleed = false, children }: AppLayoutProps) {
  const [showSettings, setShowSettings] = useState(false)
  return (
    <div>
      <header className="header">
        <div className="header-brand">
          <Link to="/" className="logo-link">
            <img
              src={`/logo.png?v=${Date.now()}`}
              alt="FarmCore"
              className="header-logo"
              onError={(e) => {
                e.currentTarget.style.display = 'none'
                e.currentTarget.nextElementSibling?.classList.add('logo-missing')
              }}
            />
            <h1>FarmCore</h1>
          </Link>
        </div>
        <div className="header-right">
          <div className="user-info">
            {user.avatarUrl ? (
              <img
                src={user.avatarUrl}
                alt={user.fullName || user.username}
                className="avatar avatar--sm"
                referrerPolicy="no-referrer"
              />
            ) : null}
            <span>
              <strong>{(user.fullName || user.username).split(' ')[0]}</strong>
            </span>
            <button className="btn btn-sm" aria-label="Settings" title="Settings" onClick={() => setShowSettings(true)}>
              ⚙️
            </button>
          </div>
          {/* Admin meta moved to Settings → About */}
        </div>
      </header>
      {showSettings && (
        <SettingsModal user={user} uptime={uptime} version={version || null} onClose={() => setShowSettings(false)} />
      )}
      <div className={fullBleed ? 'container container--fluid' : 'container'}>
        {children}
      </div>
    </div>
  )
}

export default AppLayout
